import { lazy } from 'react';

export const BlanksPageLazy = lazy(() => import('./BlanksPage'));
